import {api} from './api';
import {isApiError} from './api-errors';
import {Exception} from './exception';
import {settings} from 'store';

export const openai = {
  chat: {
    completions: async (content: string, n = 1) => {
      try {
        const response: {choices: any[], connects?: number} = await api('/openai/chat/completions/v2', {
          content,
          n,
          temperature: 0.8
        });
        if (response.connects !== undefined) {
          settings.dispatch.setGptConnects(response.connects);
        }
        const choices = response.choices.map(choice => {
          try {
            let content = choice.message.content;
            content = content.match(/```json\n([\s\S]*?)\n```/)?.[1];
            return JSON.parse(content ?? '{"invalid": true}');
          } catch {
            return {invalid: true};
          }
        });
        if (choices.some(({invalid}) => Boolean(invalid))) {
          throw new Exception('Your request is not descriptive enough. Please revise it and try again.', 'Error');
        }
        return choices;
      } catch (error) {
        if (isApiError(error) && error.code === 429) {
          throw new Exception('You have reached the ChatGPT usage limit for this month. Please try later.', 'Note');
        }
        throw error;
      }
    }
  }
};
